<script>

    import { createEventDispatcher } from 'svelte'
    import Date from './date.svelte'

    export let dateStart
    export let dateEnd
    export let showTime = true
    /** Fechas en columna (recomendado en paneles estrechos) */
    export let stacked = false

    const dispatch = createEventDispatcher()

    function onChange() {
        dispatch('change')
    }

</script>

<style>
    .date-range {
        display: flex;
        gap: 0.75rem;
        width: 100%;
        min-width: 0;
    }

    .date-range:not(.date-range_stacked) > :global(.field) {
        flex: 1;
        min-width: 0;
    }

    .date-range_stacked {
        flex-direction: column;
        align-items: stretch;
    }
</style>

<div class="date-range" class:date-range_stacked={stacked}>
    <Date on:change={onChange} bind:value={dateStart} label="Fecha inicial" {showTime} />
    <Date on:change={onChange} bind:value={dateEnd} label="Fecha final" {showTime} />
</div>
